import {
  AVOCATION_QUESTIONS_DATA_REQUEST,
  AVOCATION_QUESTIONS_DATA_SUCCESS,
  AVOCATION_QUESTIONS_DATA_FAIL,
} from '../constants/avocationConstants';

export const avocationReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case AVOCATION_QUESTIONS_DATA_REQUEST:
      return { loading: true, formData: [] };
    case AVOCATION_QUESTIONS_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case AVOCATION_QUESTIONS_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
